import styled, { css } from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

import { tabletBreakpoints } from '@context/constants';

import { Verse } from '../../../verseTheme';

export const StyledContentBlock = styled.div`
  ${({ theme }) => css`
    width: 100%;
    border-color: ${theme.palette.border.default};
    box-sizing: border-box;
    position: relative;

    min-height: calc(100vh - 160px);
    border-bottom: 0px;
    border-right: 0px;
    border-left: 0px;
    border-radius: 0px;

    ${media.md`
                min-height: unset;
                margin-bottom: 50px;
                border-radius: 24px;
            `}
    @media(min-width: ${tabletBreakpoints.xlarge}) {
      max-width: ${tabletBreakpoints.large};
      /* CardShadow */
      box-shadow: ${Verse.glowLight};
      border: 1px solid var(--color-600, ${colors.verseNavBlue});
    }
  `}
`;
